import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Button, Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import Contrainer from "../../components/Contrainer/Contrainer";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import icon from "../../resource/icon";
import { useNavigate } from "react-router-dom";
import { myEvaluationDatasource } from "../../datasource/myEvaluationDatasource";
import {
  EmptyEvaluationCard,
  EvaluationCard,
} from "../MyEvaluation/EvaluationCard";
import _ from "lodash";
import dayjs from "dayjs";
import {
  SCORE_MAPPING,
  SCORE_MAPPING_COLOR,
  SCORE_MAPPING_DES,
} from "../../definitions/score";

const IndexMyEvaluation: React.FC = () => {
  const profile = JSON.parse(localStorage.getItem("rainbowProfile")!);
  const DateFormat = "MMMM D, YYYY HH:mm";

  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [data, setData] = useState<any>([]);
  const [lastData, setLastData] = useState<any>();

  const getDataMyEvaluation = async () => {
    await myEvaluationDatasource
      .getMyEvaluation(Number(profile.employeeId))
      .then((res) => {
        let mapData: any = [];
        if (res.responseData.length > 0) {
          const checkCurrentYear = res.responseData.filter(
            (x: any) => Number(x.pmsYear) === currentYear
          );
          if (checkCurrentYear.length > 0) {
            mapData = res.responseData;
          } else {
            const loopYear =
              currentYear -
              res.responseData.sort(
                (a: any, b: any) => Number(a.pmsYear) - Number(b.pmsYear)
              )[0].pmsYear;
            mapData = res.responseData;
            for (let i = 0; loopYear > i; i++) {
              const find = res.responseData.find(
                (x: any) => Number(x.pmsYear) === currentYear - i
              );
              !find &&
                mapData.push({
                  pmsYear: String(currentYear - i),
                  isSubmit: false,
                });
            }
          }
        } else {
          mapData = [{ pmsYear: String(currentYear), isSubmit: false }];
        }

        const yearList = _.groupBy(mapData, ({ pmsYear }: any) => {
          return pmsYear;
        });

        const mapLastData: any = Object?.entries(yearList)
          .sort(([a], [b]) => Number(b) - Number(a))
          ?.map(
            ([year, items]) =>
              items.sort((x, y) => Number(y.pmsMonth) - Number(x.pmsMonth))[0]
          );
        setLastData(mapLastData[0]);
        setData(yearList);
      });
  };

  useEffect(() => {
    getDataMyEvaluation();
  }, []);

  const myLastEvaluation = () => {
    return (
      <Contrainer
        style={{
          backgroundColor: "#F3F4FB",
          borderRadius: "24px",
          padding: "34px",
          borderColor: color.gray,
          borderStyle: "solid",
          borderWidth: 1,
        }}
      >
        <Row justify={"start"} gutter={8}>
          <Col span={2} style={{ paddingLeft: "20px" }}>
            <img src={icon.evalationIcon} />
          </Col>
          <Col span={16}>
            <Text level={2} fontWeight={600}>
              {lastData?.pmsYear}{" "}
              {lastData?.pmsMonth === "13" ? "Mid Year" : "Final Year"}{" "}
              Evaluation
            </Text>
            <br />
            <Text color="gray" level={4}>
              <CalendarOutlined /> Reviewed:{" "}
              {dayjs(lastData?.supervisorSubmitDate).format(DateFormat)}
            </Text>
            <br />
            <br />
            <Button
              style={{ backgroundColor: color.navy, height: "40px" }}
              onClick={() =>
                navigate("/consentPerformance", {
                  state: { getData: lastData },
                })
              }
            >
              <Text color="white" fontWeight={700}>
                View & Acknowledge
              </Text>
            </Button>
          </Col>
          <Col span={6}>
            <Contrainer
              style={{
                borderRadius: "16px",
                padding: "10px",
                width: "100%",
              }}
            >
              <Row justify={"center"}>
                <Text fontWeight={600} level={2}>
                  Final Score
                </Text>
              </Row>
              <Row justify={"center"}>
                <Text fontWeight={600} level={1}>
                  <Text
                    fontWeight={600}
                    level={1}
                    color={
                      SCORE_MAPPING_COLOR[lastData.pmsScores[0].pmsScoreValue]
                    }
                  >
                    {SCORE_MAPPING[lastData.pmsScores[0].pmsScoreValue]}
                  </Text>
                </Text>
              </Row>
              <Row justify={"center"}>
                <Text fontWeight={600} level={5}>
                  {SCORE_MAPPING_DES[lastData?.pmsScores[0].pmsScoreValue]}
                </Text>
              </Row>
            </Contrainer>
          </Col>
        </Row>
      </Contrainer>
    );
  };

  const myEvaluationList = (item: any, year: string) => {
    const findMid = item.find((f: any) => `${f.pmsMonth}` === `13`);
    const findYear = item.find((f: any) => `${f.pmsMonth}` === `14`);
    return (
      <div>
        <Row justify="space-between" gutter={16} key={year}>
          {findMid ? (
            <EvaluationCard year={year} type="Mid" item={findMid} />
          ) : (
            <EmptyEvaluationCard year={year} type="13" />
          )}
          {findYear ? (
            <EvaluationCard year={year} type="Final" item={findYear} />
          ) : (
            <EmptyEvaluationCard year={year} type="14" />
          )}
        </Row>
        <br />
      </div>
    );
  };

  return (
    <>
      <Contrainer>
        <Row>
          <Text fontWeight={600} level={2}>
            🎯 My Performance Evaluation
          </Text>
        </Row>
        <br />
        {!lastData?.isEmployeeSubmit && lastData?.isSubmit && (
          <>
            {myLastEvaluation()}
            <br />
          </>
        )}

        <Contrainer
          style={{
            borderColor: color.gray,
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: "24px",
            padding: "20px",
          }}
        >
          <Row justify={"start"} gutter={8}>
            <Col>
              <ClockCircleOutlined
                style={{
                  fontSize: "20px",
                  color: color.gray,
                  paddingTop: "3px",
                }}
              />
            </Col>
            <Col>
              <Text level={4} fontWeight={700}>
                Evaluation History
              </Text>
            </Col>
          </Row>
          <br />
          {Object?.entries(data)
            .sort(([a], [b]) => Number(b) - Number(a))
            ?.map(([year, items]) => (
              <div key={year}>
                <Text level={4} fontWeight={700}>
                  Year {year}
                </Text>
                {myEvaluationList(items, year)}
              </div>
            ))}
        </Contrainer>
      </Contrainer>
    </>
  );
};
export default IndexMyEvaluation;
